export default __webpack_public_path__ + "static/media/modal-diamond@2x.4d75d3e1.png";